<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>The author is a resident of the Gold Coast in Queensland, Australia. David works full-time as a tradesman and writes in his spare time attending a writer’s club at Helensvale Library on the Gold Coast every week, to hone his writing skills.</p>
<p style="text-indent:0em">His first book, the <em>Night Watchman</em> has recently been accepted into all Gold Coast libraries in Queensland.</p>
<p style="text-indent:0em">His second book, <em>Naomi The Night Watchwoman</em> will be part of a proposed trilogy that he has entrusted Austin Macauley to bring to life on the international stage.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?53299c08